<template lang="pug">
  div
    el-row.margin-top
      el-col
        div.container-right
          app-display(
            label="Nome da gleba:",
            :content="cadastroGleba.nome",
            :class = "'text'"
          )
          app-display(
            label="Data de cadastro:",
            :content="formatarData(cadastroGleba.dataCadastro)",
            :class = "'text'"
          )
        app-display(
          label="Município da gleba:",
          :content="cadastroGleba.nomeMunicipiosGleba",
          :class = "'text'"
        )
        app-display(
          label="Área total (ha):",
          :content="formatarArea(cadastroGleba.areaTotal)",
          :class = "'text'"
        )
        app-display(
          label="Áreas remanescentes (ha):",
          :content="formatarArea(cadastroGleba.areaRemanescente)",
          :class = "'text'"
        )
        app-display(
          label="Cartório:",
          :content="cadastroGleba.nomeCartorio",
          :class = "'text'"
        )
        app-display(
          label="Município do cartório:",
          :content="cadastroGleba.nomeMunicipioCartorio",
          :class = "'text'"
        )
        app-display(
          label="Matrícula:",
          :content="cadastroGleba.matricula",
          :class = "'text'"
        )
        app-display(
          label="Data de matrícula:",
          :content="formatarData(cadastroGleba.dataMatricula)",
          :class = "'text'"
        )
        app-display(
          label="Livro:",
          :content="cadastroGleba.livro",
          :class = "'text'"
        )
        app-display(
          label="Folha:",
          :content="cadastroGleba.folha",
          :class = "'text'"
        )
        app-display(
          label="Latitude:",
          :content="cadastroGleba.latitude || '-'",
          :class = "'text'"
        )
        app-display(
          label="Longitude:",
          :content="cadastroGleba.longitude || '-'",
          :class = "'text'"
        )
</template>

<script>
import AppDisplay from '@/components/AppDisplay'
import moment from 'moment'
export default {

  components: {
    AppDisplay
  },

  props: {
    cadastroGleba: {
      required: true
    }
  },

  data () {
    return {
    }
  },
  mounted () {
  },

  computed: {
  },

  methods: {
    filterNull (atributo) {
      return ![null, undefined, ''].includes(atributo) ? atributo : '-'
    },
    formatarData (data) {
      return data ? moment(data).format('DD/MM/YYYY') : '-'
    },
    formatarArea (area) {
      return area ? area.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : '-'
    }
  }
}
</script>

<style lang="scss" scoped>

.bold {
  font-weight: bold;
}

.margin-top {
  margin-top: 1rem;
}

.negative-margin-top {
  margin-top: - 3rem;
}
.container-right {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/screens/bancoDados/components/InformacoesCadastro.vue